import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  proposePostApiService,
  type ProposePostRequest,
  type ProposePostResponse,
} from "@/generated/fastapi";

export async function proposePost(
  accessToken: string | null | undefined,
  request: ProposePostRequest,
): Promise<ProposePostResponse | null> {
  try {
    const response = await proposePostApiService({
      client: browserFastApiClient,
      auth: requireFastApiAccessToken(accessToken),
      body: request,
    });

    if (response.status !== 200 || !response.data) {
      console.error("Failed to propose post");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Error proposing post:", error);
    return null;
  }
}
